import React from 'react';

const SuperLikeNotification = () => {
  return (
    <div className="absolute top-0 left-0 right-0 p-2 bg-blue-500 text-white text-center text-sm font-semibold">
      Someone super liked you!
    </div>
  );
};

export default SuperLikeNotification;
